import { api } from 'common';

import { CareGapFormFields } from './FormFields';
import { careGapDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

const CareGapAlgorithm = api.FlowDefinition.CareGapAlgorithm;
type CareGapAlgorithm = api.FlowDefinition.CareGapAlgorithm;

export const careGapAlgorithmNodeConfig: BlockConfigProps<api.FlowDefinition.CareGapAlgorithmBlockConfig> =
  {
    nodeHandles: [{ type: 'target' }, { type: 'source' }],
    defaultLabelPrefix: 'careGapAlgorithm',
    defaultConfig: {
      algorithm: '' as CareGapAlgorithm,
      payload: {
        documents: {
          sourceBlockName: '',
        },
        problems: {
          sourceBlockName: '',
        },
        medications: {
          sourceBlockName: '',
        },
        labValues: {
          sourceBlockName: '',
        },
        procedures: {
          sourceBlockName: '',
        },
      },
    },
    configFields: {
      schema: api.FlowDefinition.CareGapAlgorithmBlockConfigSchema,
      FormFields: CareGapFormFields,
    },
    documentationMarkdown: careGapDocumentationMarkdown,
  };
